import { http } from './http';
import { ROUTES } from './config';
import type { ConversationHistory, ConversationSummary, SendMessageRequest } from '../types/domain';

/** CrmService MessagesController client. Any authenticated role — customer sees their own
 * single conversation, manager/admin see every conversation (inbox). */
export const messagesApi = {
  inbox(): Promise<ConversationSummary[]> {
    return http.get(ROUTES.messages);
  },

  history(conversationId: string, before?: string): Promise<ConversationHistory> {
    const q = before ? `?before=${encodeURIComponent(before)}` : '';
    return http.get(`${ROUTES.messages}/${conversationId}${q}`);
  },

  send(body: SendMessageRequest): Promise<{ conversationId: string; id: string; sentAt: string }> {
    return http.post(ROUTES.messages, body);
  },

  markRead(conversationId: string): Promise<void> {
    return http.post(`${ROUTES.messages}/${conversationId}/read`);
  },

  /** Manager/admin only (RequireRoles enforced in CrmService) — asks ai-engine's real RAG
   * chat for a draft reply to the customer's latest message, grounded in the seeded
   * product/CMS/site corpus. `suggestion` is null when there's no customer message yet or
   * ai-engine is unreachable/blocked the request — `reason` explains which. Never sent
   * automatically; the caller must review/edit and send via `send()` above. */
  suggestReply(conversationId: string): Promise<{ suggestion: string | null; citations: string[]; reason?: string }> {
    return http.get(`${ROUTES.messages}/${conversationId}/suggest-reply`);
  },
};
